import { render, staticRenderFns } from "./OrderFormMod.vue?vue&type=template&id=bee4f4be"
import script from "./OrderFormMod.vue?vue&type=script&lang=js"
export * from "./OrderFormMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports